module.exports = __webpack_public_path__ + "static/media/edenred_light_italic.85c40b6b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/edenred_light_italic.woff
// module id = 263
// module chunks = 1